import { Component, input } from '@angular/core';

@Component({
  selector: 'app-loader',
  template: `
    <svg class="app-spinner" viewBox="0 0 48 48" aria-hidden="true">
      <circle class="track" cx="24" cy="24" r="20" />
      <circle class="arc" cx="24" cy="24" r="20" />
    </svg>
  `,
  styleUrl: './loader.component.scss',
  host: {
    role: 'status',
    '[attr.aria-label]': 'label()',
    '[style.--spinner-size.px]': 'size()',
  },
})
export class LoaderComponent {
  size = input(28);

  label = input('Loading');
}
